<div class="client-wrapper">
  <section class="top-bar">
    <app-navbar></app-navbar>
  </section>
  <section class="bl-main-wrapper">
    <router-outlet></router-outlet>
  </section>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12 footer-logo">
          <img src="../../assets/images/logo-header.svg" alt="PowerUp! by EIT InnoEnergy">
          <img src="../../assets/images/EU_logo.png" alt="">
        </div>
      </div>
    </div>
  </footer>
</div>